{
  "roles": "Roles",
  "listOfRoles": "List of Roles",
  "roleTitle": "Role - {{description}}",
  "save": "Save",
  "nameLabel": "Name",
  "informationAccessLabel": "Information Access",
  "informationUpdatesLabel": "Information Updates",
  "addNewRoleTitle": "Add new Role",
  "deleteRoleTitle": "Are you sure you want to delete the role?",
  "deleteRoleSubtitle": "This action will permanently delete the role and cannot be undone. Are you want to proceed?",
  "deleteRoleCancel": "No, Keep Role",
  "deleteRoleConfirm": "Yes, Delete Role",
  "deleteRoleLabel": "Delete role {{description}}",
  "backToRoles": "Back to List of Roles"
}
